export default __webpack_public_path__ + "77fb6a8077cf6b176018b46e5171129c.png";